import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { beforeNFT, getNFTs } from '../nfts/nfts.action';
import { ENV } from '../../config/config';
import FullPageLoader from '../full-page-loader/full-page-loader'
import { Link, useHistory } from 'react-router-dom';
import FilterSearch from "../filter-search/filtersearch";
import ReactTooltip from 'react-tooltip'

const initData = {
    pre_heading: "Explore",
    heading: "Exclusive Digital Assets",
    content: "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Laborum obcaecati dignissimos quae quo ad iste ipsum officiis.",
    btn_1: "Load More"
}

function ExploreAll(props) {
    const [nftPagination, setNFTPagination] = useState(null);
    const [nfts, setNFTs] = useState([]); // NFTs for explore section
    const [loader, setLoader] = useState(true);
    const [loadMoreBtn, setLoadMoreBtn] = useState(false);
    const [isMoreClicked, setLoadMore] = useState(false); // flag to check if load more button clicked
    const [intro, setIntro] = useState(false);
    const [searchAndFilters, setSearchAndFilters] = useState(false);
    const [nftFilter, setNftFitler] = useState(null);
    const pathname = useHistory().location.pathname
    const [Filter, setFilter] = useState(false);  // flag for responsive view only

    useEffect(() => {
        window.scroll(0, 0)
        // set intro section
        if (pathname === '/explore-all') {
            setIntro(true)
            setSearchAndFilters(true)
        }

        // get NFTs for explore section
        getNFTs()
    }, [])

    // set NFTs for explore section
    useEffect(() => {
        if (props.nft.nftsAuth) {
            const { nftsData } = props.nft
            console.log(nftsData)
            if (nftsData) {
                setNFTs(isMoreClicked ? nfts.concat(nftsData.nfts) : nftsData.nfts)
                setNFTPagination(nftsData.pagination)
                if (nftsData.nfts.length) {
                    setLoadMoreBtn(true)
                }
                if (nftsData.pagination.page === nftsData.pagination.pages) {
                    setLoadMoreBtn(false)
                }
                props.beforeNFT()
                setLoader(false)
                setLoadMore(false)
                if (props.setLoader)
                    props.setLoader(false)
            }
        }
    }, [props.nft.nftsAuth])

    const loadMore = () => {
        const { page } = nftPagination
        setLoader(true)
        setLoadMore(true)
        // get more NFTs for explore section
        getNFTs(page + 1, 40, nftFilter)
    }

    const getNFTs = (page = 1, limit = 40, filter = null) => {
        let nftQS = { page, limit, explore: true }

        if (filter)
            nftQS = { ...nftQS, ...filter }

        if (props.collectionId)
            nftQS.collectionId = props.collectionId

        if (props.authorId)
            nftQS.authorId = props.authorId

        const qs = ENV.objectToQueryString(nftQS)
        props.getNFTs(qs)
    }

    // apply search & filters
    useEffect(() => {
        if (props.filter)
            applyFilters(props.filter)
    }, [props.filter])

    const applyFilters = (filter) => {
        if (filter) {
            setLoader(true)
            setNftFitler(filter)
            getNFTs(1, 40, filter)
        }
    }

    return (
        <section className="explore-area">
            {loader && <FullPageLoader />}
            <div className="container-fluid p-0">
                {
                    intro &&
                    <div className="row justify-content-center">
                        <div className="col-12 col-md-8 col-lg-7">
                            <div className="intro text-center">
                                {/* <span>{initData.pre_heading}</span> */}
                                <h3 className="mt-3 mb-0">{initData.heading}</h3>
                                <p>{initData.content}</p>
                            </div>
                        </div>
                    </div>
                }
                <div className={` ${Filter ? 'active' : ''} d-flex collection-wrapper`}>
                    <button className="side-toggle-btn" onClick={() => setFilter(!Filter)}><i className="fas fa-sort-amount-down-alt" /></button>
                    {
                        searchAndFilters &&
                        <FilterSearch applyFilters={applyFilters} showColFilters={true} showCatFilters={true} showAuthorFilters={true} />
                    }
                    <div className="nfts-collection-wrapper w-100">
                        <div className="row items explore-items">
                            {nfts && nfts.length > 0 ?
                                nfts.map((item, idx) => {
                                    return (
                                        <div key={`edth_${idx}`} className={`col-12 col-sm-6 col-lg-4 col-xl-${props.lgCols ? props.lgCols : '3'} item explore-item`} data-groups={item.group ? item.group : '["art","sports"]'}>
                                            <div className="card">
                                                <div className="image-over">
                                                    <Link to={`/item-details?item=${window.btoa(item._id)}`}>
                                                        <img className="card-img-top" src={item.image} alt="img" />
                                                    </Link>
                                                </div>
                                                <div className="card-caption col-12 p-0">
                                                    <div className="card-body">
                                                        <Link to={`/item-details?item=${window.btoa(item._id)}`}>
                                                            <h5 className="mb-0">{item.name}</h5>
                                                        </Link>
                                                        <div className="seller d-flex align-items-center my-3">
                                                            <span>Owned By</span>
                                                            <Link to={`/author/${item.owner._id}`} data-effect="float" data-tip={item.owner.username}>
                                                                <h6 className="ml-2 mb-0">{item.owner.username}</h6>
                                                            </Link>
                                                            <ReactTooltip />
                                                        </div>
                                                        <div className="card-bottom d-flex justify-content-between">
                                                            <span>{item.currentPrice} {item.currency}</span>
                                                            {/* <span>{item.sold} of {item.copies}</span> */}
                                                        </div>
                                                        {/* <a className="btn btn-bordered-white btn-smaller mt-3" href="/login"><i className="icon-handbag mr-2" />Place a Bid</a> */}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    );
                                })
                                : <div className="no-data border"><p className="text-center">No Items Found to Explore</p></div>
                            }
                        </div>
                    </div>
                </div>
                {loadMoreBtn ?
                    <div className="row">
                        <div className="col-12 text-center mb-3">
                            <a id="load-btn" className="btn btn-bordered-white mt-4" onClick={() => loadMore()} href>{initData.btn_1}</a>
                        </div>
                    </div>
                    : ''
                }

                {/* <ExploreItems class1="explore-items" class2="explore-item" key="edth" /> */}
            </div>
        </section>
    )
}

const mapStateToProps = state => ({
    nft: state.nft
});

export default connect(mapStateToProps, { beforeNFT, getNFTs })(ExploreAll);